import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from '../SortContainer';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortTypes } from '../../../search.types';
import { SortButton } from './SortButton';
import { TextButton } from '../../../../components/button';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import styles from './sort_dropdown.module.scss';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

type State = {
  isOpen: boolean;
};

export class RawSortDropdown extends React.Component<Props, State> {
  wrapperRef = React.createRef<HTMLDivElement>();

  state: State = {
    isOpen: false,
  };

  componentDidMount() {
    window.addEventListener('click', this.onDocumentClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick = (event: MouseEvent) => {
    if (
      this.wrapperRef.current &&
      event.currentTarget &&
      !this.wrapperRef.current.contains(event.target as Node) &&
      this.state.isOpen
    ) {
      this.setState({
        isOpen: false,
      });
    }
  };

  openShareDropdownClicked = () => {
    this.setState(state => ({
      isOpen: !state.isOpen,
    }));
  };

  changeSortClicked = (type: SortTypes) => () => {
    const { accessPremium, onSortUpdate, openRestrictedModal } = this.props;
    if (!accessPremium) {
      openRestrictedModal(searchConstants.sorts[type].event);
    } else {
      this.setState({
        isOpen: false,
      });
      doctrineAnalytics('Search FilterSortClicked', { sort: type });
      onSortUpdate(type);
    }
  };

  render() {
    const { selectedSort, displayCommentariesSearch } = this.props;
    const { isOpen } = this.state;

    return (
      <div ref={this.wrapperRef} className={classNames(styles.container)}>
        <TextButton
          iconRight="arrow_drop_down"
          onClick={this.openShareDropdownClicked}
        >
          <FormattedMessage id="search/components/search-sort/sort-dropdown/SortDropdown.tsx/1" />
          {'\u00A0'}
          <span className={styles.bold}>
            <FormattedMessage
              id={searchConstants.sorts[selectedSort].labelId}
            />
          </span>
        </TextButton>
        {isOpen && (
          <div className={styles.dropdown}>
            <SortButton
              isSelected={selectedSort === 'relevance'}
              type="relevance"
              handleClick={this.changeSortClicked}
            />
            <SortButton
              isSelected={selectedSort === 'chrono'}
              type="chrono"
              handleClick={this.changeSortClicked}
            />
            <SortButton
              isSelected={selectedSort === 'antiChrono'}
              type="antiChrono"
              handleClick={this.changeSortClicked}
            />
            {displayCommentariesSearch && (
              <SortButton
                isSelected={selectedSort === 'commented'}
                type="commented"
                handleClick={this.changeSortClicked}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

export const SortDropdown = withUser(
  withRestrictedModal(Connect(RawSortDropdown)),
);
